import { getFileSize, isFile } from '@/shared/utils'

export const getFileSizeInBytes = (size: number, unit: string) => {
  if (unit === 'kb') return size * 1024
  if (unit === 'mb') return size * 1024 * 1024
  if (unit === 'gb') return size * 1024 * 1024 * 1024
  return size
}

export const getFileExtensionAndSize = (value: string | File | null) => {
  if (!isFile(value)) return { fileType: '', fileSize: 0 }

  const fileExtension = value.name.split('.').pop()
  const fileSize = getFileSize(value.size)

  return { fileExtension, fileSize }
}


export const validateFileTypes = (value: string | File | null, acceptedFileTypes: string[]) => {
  if (!isFile(value)) return true
  const fileExtension = '.' + value.name.split('.').pop()?.toLowerCase()
  return acceptedFileTypes.map(type => type.toLowerCase()).includes(fileExtension)
}
